export const EVIDENCE_CHIP_SIDE_OFFSET_PX = 8
export const EVIDENCE_CHIP_HOVER_OPEN_DELAY_MS = 75
export const EVIDENCE_CHIP_HOVER_CLOSE_DELAY_MS = 150

const CONTENT_LEAVE_EDGE_SLACK_PX = 2

export function isInsideHoverCardContent(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    Boolean(target.closest('[data-slot="hover-card-content"]'))
  )
}

export function isInsideHoverCardTrigger(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    Boolean(target.closest('[data-slot="hover-card-trigger"]'))
  )
}

export function isPointerLeavingTowardContent(
  clientX: number,
  clientY: number,
  triggerRect: DOMRect
): boolean {
  const leavingDown =
    clientY >= triggerRect.bottom - CONTENT_LEAVE_EDGE_SLACK_PX
  const leavingUp = clientY <= triggerRect.top + CONTENT_LEAVE_EDGE_SLACK_PX
  const withinHorizontalBounds =
    clientX >= triggerRect.left && clientX <= triggerRect.right
  return (leavingDown || leavingUp) && withinHorizontalBounds
}

export function shouldAllowContentKeepAliveOnTriggerLeave(options: {
  relatedTarget: EventTarget | null
  clientX: number
  clientY: number
  triggerRect: DOMRect
}): boolean {
  if (isInsideHoverCardContent(options.relatedTarget)) return true
  return isPointerLeavingTowardContent(
    options.clientX,
    options.clientY,
    options.triggerRect
  )
}
